<div class="turn-steps font-heading">
	<span>1. RESUPPLY</span>
	<span>2. CONTROL (MAX: 1)</span>
	<span>3. ACTIONS (3)</span>
	<span>4. CLEAN-UP</span>
	<div class="cleanup-steps">
		<span>A. RESOLVE STARDATE</span>
		<span>B. PLACE GLORY</span>
		<span>C. DISCARD & DRAW</span>
	</div>
</div>

<style>
	.turn-steps {
		flex-direction: column;
		flex-grow: 1;
		flex-basis: 0;
		font-size: calc(var(--height) / 20.05); /*20px;*/
		color: azure;
		justify-content: center;
		padding-left: 3em;
		gap: 1px;
	}
	.cleanup-steps {
		flex-direction: column;
		font-size: calc(var(--height) / 25.0625); /*16px;*/
		padding-left: 2em;
		gap: calc(var(--height) / 133.667); /*3px;*/
	}
</style>
